import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Parallax {
  constructor(dom) {
    this.dom = dom;
    this.img = false;
    this.init();
  }

  init() {
    if (this.dom.classList.contains('js-parallax')) {
      this.img = this.dom;
    }

    if (this.img) {
      gsap.to(this.img, {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
        ease: 'power3.out',
      });

      gsap.from(this.img, {
        yPercent: 40,

        scrollTrigger: {
          trigger: this.dom,
          start: '10% bottom',
          end: `110% top`,
          scrub: true,
        },
        ease: 'None',
      });
    } else {
      gsap.from(this.dom, {
        yPercent: -30,

        scrollTrigger: {
          trigger: this.dom,
          start: 'top bottom',
          end: `bottom top`,
          scrub: true,
        },
        ease: 'None',
      });
    }
  }
}

export default Parallax;
